FeatureSet = require 'lib/feature-set'

individualFeatures = [
  'additionalStickers'
  'customStickers'
  'additionalBoardBackgrounds'
  'customBoardBackgrounds'
  'largeAttachments' # can upload larger attachments
  'customEmoji'
  'savedSearches'
]

trelloGoldFeatures = [
  individualFeatures...
  'crown'
  'readSecrets' # Share a link that grants a read only view of a board or card
  'threePlugins' # Can enable up to three plugins on any board
]

trelloGoldFromBCFeatures = [
  individualFeatures...
  'infinitePlugins' # You can enable as many plugins as you want on any board
]

products =
  10:
    shortName: 'trelloGoldFromBC'
    name: "Trello Gold from BC"
    features: trelloGoldFromBCFeatures
  37:
    shortName: 'trelloGoldMonthly'
    name: "Trello Gold"
    interval: 'monthly'
    price: 5
    features: trelloGoldFeatures
    yearlyEquivalent: 38
  38:
    shortName: 'trelloGoldYearly'
    name: "Trello Gold"
    interval: 'yearly'
    price: 45
    features: trelloGoldFeatures

opts =
  currentProducts:
    monthly: 'trelloGoldMonthly'
    yearly: 'trelloGoldYearly'
  extras:
    currentPriceObjectForModel: (member) ->
      monthlyProduct = @currentProducts.monthly
      yearlyProduct = @currentProducts.yearly

      monthly:
        productNumber: @getProductNumber(monthlyProduct)
        price: @getPrice(monthlyProduct)
        monthlyPrice: @getPrice(monthlyProduct)
      yearly:
        productNumber: @getProductNumber(yearlyProduct)
        price: @getPrice(yearlyProduct)
        monthlyPrice: @getPrice(yearlyProduct) / 12
        savePercent: @getYearlyDiscountPercent(yearlyProduct, monthlyProduct)
      billingStrategy:
        flatRate: true

module.exports = new FeatureSet(products, opts)



// WEBPACK FOOTER //
// ./app/scripts/data/member-features.coffee